/* eslint-disable */
import { Grid, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import * as context from 'api/base';
import Icon from '@mui/material/Icon';
import { Link } from 'react-router-dom';
import useWindowDimensions from '../../../../../utils/useWindowDimensions';
import { getIconDetails } from 'utils/getOptionIconDetails';
import { useSelector } from 'react-redux';
import { getNewBuyInsurancePathGeneric } from '../../routes/generic/Helpers/HomePageHelper';
import { getPagesButtonName } from '../../routes/generic/Helpers/GenericHelper';
import { productOptionCardStyles } from '../styles/widgetStyles';

function ProductOptionDetailedCardWidget(props) {
	let themeinfo = context.getSettings();
	const theme = useTheme();
	const { width } = useWindowDimensions();
	const classes = productOptionCardStyles(theme, themeinfo, width);
	let productOptionsInfo = context.getProductOptions(props?.productInstanceId);
	const channelProducts = useSelector(({ fuse }) => fuse.form.channelProducts);
	const referenceTokenDetails = useSelector(({ fuse }) => fuse.form.referenceTokenDetails);
	const myHostPrefix = useSelector(({ fuse }) => fuse.form.mySite.hostPrefix);

	const navigate = name => {
		return getNewBuyInsurancePathGeneric(channelProducts, referenceTokenDetails?.token, myHostPrefix);
	};

	const prodItems = [];
	productOptionsInfo
		.filter(opt => props?.productOptionId === opt.instanceId || props?.productOptionId === undefined)
		.forEach(pitem =>
			prodItems.push(
				<Grid
					item
					key={pitem.instanceId}
					className={clsx(
						'w-full h-100 text-left p-12',
						props.columnType === 'ONE' ? 'sm:w-full self-center' : 'sm:w-1/2'
					)}
					xs={12}
					md={6}
					lg={props.columns || 4}
					xl={props.columns || 4}
				>
					<Card className={clsx('rounded-10')} sx={classes.card}>
						<div className={clsx('px-10 md:px-24 py-16')} style={classes.cardHeader}>
							<Typography variant="h4" className="text-xl md:text-3xl font-bold mr-10">
								{getIconDetails(pitem)?.isVisible && (
									<Icon fontSize="inherit" sx={classes.cardIcon}>
										<img src={getIconDetails(pitem)?.iconSource} />
									</Icon>
								)}
								{pitem.contents['OPTION-NAME']}
							</Typography>
						</div>
						<CardContent className="p-10 md:p-32">
							<div className="flex flex-col">
								<div
									dangerouslySetInnerHTML={{
										__html: pitem.contents[`OPTION-${props?.descriptionType}`]
									}}
								/>
								<br />
								<Link to={'/fast-facts-options/' + pitem.productInstanceId}>
									<strong style={classes.cardClickForMore}>[Fast Facts Comparison]</strong>
								</Link>
							</div>
						</CardContent>

						<div className={clsx('flex pb-32')} style={classes.cardFooter}>
							<div className={clsx('px-10 md:px-32')} style={classes.cardButtonMain}>
								<Button
									sx={classes.cardButton}
									component={Link}
									to={navigate(pitem.name)}
									variant="contained"
									color="primary"
									name={getPagesButtonName({
										pageName: 'Landing',
										buttonName: `${pitem.contents['OPTION-NAME']} Get Cover Now`
									})}
									data-ga-label={`product-option-card-get-cover-now-${pitem?.instanceId?.split('-')?.pop()}}`}
								>
									Get Cover Now
								</Button>
							</div>
						</div>
					</Card>
				</Grid>
			)
		);

	return (
		<div className="w-full my-32">
			<Grid
				container
				justifyContent="center"
				alignItems="stretch"
				flexDirection={props.columnType === 'ONE' ? 'column' : 'row'}
			>
				{prodItems}
			</Grid>
		</div>
	);
}

export default ProductOptionDetailedCardWidget;
